import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, " Your title describes you, it can be anything you want, but it cannot be changed once minted. The more title you have, the more expensive a new title will be. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createBlock(_component_Modal, {
            key: 0,
            ref: "modal",
            modalTitle: "Add a new title",
            onClosed: _cache[3] || (_cache[3] = ($event: any) => (_ctx.show = false))
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                class: "border w-full h-12 px-3",
                placeholder: "type your title here",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.content) = $event)),
                id: "ens_title",
                onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.doSearch && _ctx.doSearch(...args)), ["enter"]))
              }, null, 544), [
                [_vModelText, _ctx.content]
              ]),
              _hoisted_1,
              _createElementVNode("div", {
                class: _normalizeClass(["red-button mt-8 w-40 text-center mx-auto", [_ctx.content ? '' : 'opacity-50']]),
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submitTitle && _ctx.submitTitle(...args)))
              }, " Submit ", 2)
            ]),
            _: 1
          }, 512))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}